// Catalogo padronizado de IDs de CTA (snake_case)
// Usar sempre os IDs abaixo para cta_clicked

export const LANDING_CTAS = {
  HERO_PRIMARY: "hero_primary",
  HERO_SECONDARY: "hero_secondary",
  TSHIRT_BUY: "tshirt_buy",
  TSHIRT_CHECK_STATUS: "tshirt_check_status",
  NAV_GALLERY: "nav_gallery",
  FORM_CHECK_STATUS: "form_check_status",
  FORM_SUBMIT: "form_submit",
  CTA_PRIMARY: "cta_primary",
  FOOTER_INSTAGRAM: "footer_instagram",
  FOOTER_FACEBOOK: "footer_facebook",
  FOOTER_WHATSAPP: "footer_whatsapp",
  WHATSAPP_CONTACT: "whatsapp_contact",
  PIX_COPY_CODE: "pix_copy_code",
  REOPEN_REGISTRATION: "reopen_registration",
} as const;

export const GALLERY_CTAS = {
  VIEW_ALBUM: "view_album",
} as const;
